var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex"}},[_c('sf-card',{staticStyle:{"margin-top":"-4px","margin-left":"19px"},attrs:{"width":"1800px","height":"330px","title":_vm.getMessage_('QWCC001701')}},[_c('line-chart',{ref:"grpLine",attrs:{"height":280,"chartData":_vm.datacollection1,"options":_vm.options1}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }